import script from "./sendBox.vue?vue&type=script&setup=true&name=sendBox&lang=js"
export * from "./sendBox.vue?vue&type=script&setup=true&name=sendBox&lang=js"

import "./sendBox.vue?vue&type=style&index=0&id=29ba8dd8&scoped=true&lang=css"
import "./sendBox.vue?vue&type=style&index=1&id=29ba8dd8&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29ba8dd8"]])

export default __exports__